import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class Constantes {

    constructor() { }

    TITULO_CREAR = 'Guardar';
    TITULO_ACTUALIZAR = 'Actualizar';
    TITULO_ELIMINAR = 'Eliminar';

    TEXTO_CREAR = '¿Está seguro de guardar ';
    TEXTO_ACTUALIZAR = '¿Está seguro de actualizar ';
    TEXTO_ELIMINAR = '¿Está seguro de eliminar ';
    TEXTO_ACTIVAR = '¿Está seguro de activar ';
    TEXTO__INACTIVAR = '¿Está seguro de inactivar ';

    TIEMPO_EXPIRACION_MINUTOS = 60;
};